import { useCallback } from "react";

import type { DashboardConfig } from "@lib/dashboardConfig";
import { StorageManager } from "@lib/storageManager";

import { useBrazeDashboardConfig } from "./useBrazeDashboardConfig";
import { useMutateBrazeDashboardConfig } from "./useMutateBrazeDashboardConfig";

/**
 * Mutates the features and saves the overrides to the local storage
 */
export const useMutateFeatures = (): ((value: Partial<DashboardConfig["features"]>) => void) => {
  const features = useBrazeDashboardConfig("features");
  const setFeatures = useMutateBrazeDashboardConfig("features");

  return useCallback(
    (overrides: Partial<DashboardConfig["features"]>) => {
      if (StorageManager.get(StorageManager.KEYS.BRAZE_DEBUG_PERSIST_FF_OVERRIDES)) {
        const currentOverrides = StorageManager.get(StorageManager.KEYS.BRAZE_DEBUG_FF_OVERRIDES) || {};
        StorageManager.set(StorageManager.KEYS.BRAZE_DEBUG_FF_OVERRIDES, {
          ...currentOverrides,
          ...overrides,
        });
      }

      setFeatures({
        ...features,
        ...overrides,
      });
    },
    [features, setFeatures]
  );
};
